import { IconDefinition } from "./types";

const plus: IconDefinition = {
  iconName: "plus",
  width: 16,
  height: 16,
  svgPathData: "M8 .929V15.07M15.071 8H.93",
  iconType: "stroke",
};

export { plus };
